import React from 'react';
import FooterMenu, { FooterMenuItem } from '../FooterMenu';
import LinkManager from '../../lib/LinkManager';
import { MentalLinkIdentifier, MentalFooterMenuLayout } from '../../types';

type Props = {
    mentalLinkIdentifier: MentalLinkIdentifier,
    layout: MentalFooterMenuLayout,
};

const MentalFooterMenu: React.FC<Props> = ({ mentalLinkIdentifier, layout }: Props) => {
    const items: Array<FooterMenuItem> = [{
        caption: 'Übungen',
        exact: true,
        iconUrl: layout.lessonsIcon.default,
        iconActiveUrl: layout.lessonsIcon.active,
        activeColor: layout.activeColor,
        link: LinkManager.getMentalLessonIndexLink(mentalLinkIdentifier),
    },
    {
        caption: 'Know how',
        exact: false,
        iconUrl: layout.knowhowIcon.default,
        iconActiveUrl: layout.knowhowIcon.active,
        activeColor: layout.activeColor,
        link: LinkManager.getKnowHowIndexLink(mentalLinkIdentifier),
    }];

    return (
        <FooterMenu items={items} visibility="always" className="mentals-menu" />
    );
};

export default MentalFooterMenu;
